import { NgModule } from '@angular/core';
import { FileLinkPipe } from './file-link.pipe';

@NgModule({
  declarations: [FileLinkPipe],
  exports: [FileLinkPipe]
})
export class FileLinkPipeModule { }
